import React from 'react';
import { Grid } from '@mui/material';
import SearchBar from '../../../components/SearchBar';
import StatusFilter from './StatusFilter';

const EventFilters = ({ searchTerm, onStatusChange, selectedStatus, onSearchChange, onSearchKeyPress }) => {
  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1}>
        <Grid item>
          <SearchBar searchTerm={searchTerm} onSearchChange={onSearchChange} onSearchKeyPress={onSearchKeyPress} />
        </Grid>
        <Grid>
          <StatusFilter value={selectedStatus} onChange={onStatusChange} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EventFilters;
